import { render, staticRenderFns } from "./UserSubscriptions.vue?vue&type=template&id=b8c4d7dc&scoped=true"
import script from "./UserSubscriptions.vue?vue&type=script&lang=js"
export * from "./UserSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./UserSubscriptions.vue?vue&type=style&index=0&id=b8c4d7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c4d7dc",
  null
  
)

export default component.exports